<template lang="html">
  <span>
    <v-btn   
      :disabled="role.name === 'SUPERADMIN'"           
      small     
      color="hrissecondary"
      class="white--text"
      @click.stop="drawer = true"
    >
      Configure
    </v-btn>
    <v-navigation-drawer
      v-model="drawer"      
      app
      right
      width="550"
      temporary
    >
      <v-toolbar
        color="hrissecondary" 
        dark
      >
        <v-app-bar-nav-icon @click="drawer = false" />
        <v-toolbar-title class="white--text">
          {{ role.name }}
        </v-toolbar-title>
      </v-toolbar>
      <div 
        data-simplebar 
        class="overflow"
      >
        <v-form>      
          <v-container>
            <v-row 
              v-for="(item,index) in permissionGroups"
              :key="index"
            >
              <v-col           
                cols="12"
              >
                <v-autocomplete
                  v-model="selected[index]"
                  :disabled="!$hasPermissionTo(['update configuration roles'])"
                  :items="item"
                  :label="index.toUpperCase()"
                  :placeholder="index.toUpperCase() + ' Permissions'"
                  class="hasScrollBar"
                  clearable
                  hide-no-data
                  hide-selected
                  item-text="permission_group_name"
                  multiple
                  chips
                  menu-props="auto"
                  return-object
                >
                  <template v-slot:selection="data">
                    <v-chip
                      :input-value="data.selected"
                      close
                      class="chip--select-multi"
                      @click:close="remove(index,data.item)"
                    >
                      {{ data.item.permission_group_name }}
                    </v-chip>
                  </template>
                </v-autocomplete>            
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </div>
      <v-footer
        fixed
        height="76"
      > 
        <v-spacer />  
        <v-btn
          v-if="$hasPermissionTo(['update configuration roles'])"
          :disabled="loading"
          :loading="progressing"
          block
          color="hrissecondary"
          class="white--text"
          @click="submitForm"
        >
          Save 
        </v-btn>        
      </v-footer>
    </v-navigation-drawer>
  </span>
</template>

<script>
  export default {
    props: {
      role: {
        type: Object,
        required: true,
      },
    },
    data () {
      return {
        drawer: null,
        permissionGroups: {},
        selected: {},
        loading: false,
        progressing: false,
      }
    },
    watch: {
      drawer: function (value) {
        if (value) {
          this.permissionGroups = null

          this.loadRolePermissions()
        }
      },
    },
    methods: {    
      loadRolePermissions () {
        this.loading = true

        this.$http.all([
          this.$api.permissionGroups().list(), 
          this.$api.rolePermissions().list(this.role.id),
        ])
          .then(this.$http.spread((basePermissions, rolePermissions) => {
            this.permissionGroups = basePermissions.data
            
            this.setRolePermissions(rolePermissions.data)

            this.loading = false
          }))
      },
      submitForm () {
        this.progressing = true

        this.$api.rolePermissions().update(this.role.id, this.prepareFormData())
          .then((res) => {
            if (res.status >= 200 && res.status < 300) {
              this.updated()
        
              this.$http.get('/api/cache/clear')
            }
          })
          .catch(() => {})
          .then(() => {
            this.progressing = false
          })
      },
      setRolePermissions (rolePermissions) {
        for (let key in this.permissionGroups) {
          this.selected[key] = [] // init empty arr

          this.permissionGroups[key].forEach((permissionGroup) => {
            if (this.hasPermissionGroup(permissionGroup.permission_list, rolePermissions) === true) {
              this.selected[key].push(permissionGroup)
            }
          })

          this.$forceUpdate()        
        }
      },    
      remove (key, item) {
        let index = this.selected[key].findIndex(selected => selected.id === item.id)
        if (index >= 0) this.selected[key].splice(index, 1)
      },
      hasPermissionGroup (permissionList, rolePermissions) {
        for (let x = 0; x < permissionList.length; x++) {
          let found = rolePermissions.find((permission) => {
            return parseInt(permission) === parseInt(permissionList[x])
          })

          if (found === undefined) {
            return false
          }
        }

        return true
      },
      prepareFormData () {
        let permissions = []

        for (let key in this.selected) {
          this.selected[key].forEach((permissionGroup) => {
            permissions = permissions.concat(permissionGroup.permission_list)
          })
        }

        return permissions.filter(this.onlyUnique)
      },
      onlyUnique (value, index, self) { 
        return self.indexOf(value) === index
      },
      updated () {
        this.$snack({
          message: this.role.name + "'s permissions are updated successfully",
        })
      },
    },

  }
</script>

<style lang="css" scoped>
  .overflow::-webkit-scrollbar { 
    display: none;  
  }

  .overflow {
    height: 80vh;
  }
</style>
